import * as Immutable from "immutable";
export default class Group {
  constructor(id, name, title, membersTotal, membersExcerpt) {
    this._value = {
      id,
      name,
      title,
      membersTotal,
      membersExcerpt
    };
  }
  get id() {
    return this._value.id;
  }
  get name() {
    return this._value.name;
  }
  get title() {
    return this._value.title;
  }
  get membersTotal() {
    return this._value.membersTotal;
  }
  get membersExcerpt() {
    return this._value.membersExcerpt;
  }
  toBuilder() {
    const { id, name, title, membersTotal, membersExcerpt } = this._value;
    return new Builder(
      Immutable.Map({
        id,
        name,
        title,
        membersTotal,
        membersExcerpt
      })
    );
  }
  static create(id, name, title, membersTotal, membersExcerpt) {
    return new Group(id, name, title, membersTotal, membersExcerpt);
  }
  toJSON() {
    const { id, name, title, membersTotal, membersExcerpt } = this._value;
    return {
      id,
      name,
      title,
      members_total: membersTotal,
      members_excerpt: membersExcerpt
    };
  }
  static fromJSON(value) {
    const { id, name, title, members_total: membersTotal, members_excerpt: membersExcerpt } = value;
    return Group.create(id, name, title, membersTotal, Immutable.List(membersExcerpt));
  }
  static builder() {
    return new Builder();
  }
}
class Builder {
  constructor(value = Immutable.Map()) {
    this.value = value;
  }
  id(value) {
    return new Builder(this.value.set("id", value));
  }
  name(value) {
    return new Builder(this.value.set("name", value));
  }
  title(value) {
    return new Builder(this.value.set("title", value));
  }
  membersTotal(value) {
    return new Builder(this.value.set("membersTotal", value));
  }
  membersExcerpt(value) {
    return new Builder(this.value.set("membersExcerpt", value));
  }
  build() {
    const { id, name, title, membersTotal, membersExcerpt } = this.value.toObject();
    return new Group(id, name, title, membersTotal, membersExcerpt);
  }
}
